import React, { useEffect, useState } from "react";
import { Grid, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { useLoaderData } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import ApplicationSettings, {
  redux_applicationSettings,
} from "../Redux/ApplicationSettings";
import { redux_LoginSettings } from "../Redux/LoginSettings";
import { getAccountConfig, loginApi } from "../Apis/Endpoints/LoginApi";
import md5 from "md5";
import AlertComponent from "../Components/Structure/AlertComponent";
import { redux_login } from "../Redux/Account";
import LoginImage from "../Images/Universal/Login.png";
import packageJson from "../../package.json";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

function Login() {
  // 1) Data
  const server_settings = useLoaderData();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const navigate = useNavigate();
  const prefixNums = [
    {
      code: "GR",
      en: "Greek",
      prefix: "30",
      iso2: "GR",
    },
    {
      code: "US",
      en: "United States",
      prefix: "1",
      iso2: "US",
    },
    {
      code: "BG",
      en: "Bulgaria",
      prefix: "359",
      iso2: "BG",
    },
    {
      code: "ES",
      en: "Spain",
      prefix: "34",
      iso2: "ES",
    },
    {
      code: "CN",
      en: "China",
      prefix: "86",
      iso2: "CN",
    },
  ];
  const [webUrl, setwebUrl] = useState(null);
  const [serverID, setserverID] = useState(-1);
  const [prefix, setprefix] = useState(30);
  const [username, setusername] = useState("");
  const [password, setpassword] = useState("");
  const [wrong, setwrong] = useState(false);
  const [errorMessage, seterrorMessage] = useState("");
  const [token, setToken] = useState("");
  const [useCustomeApiKey, setuseCustomeApiKey] = useState(false);
  const [mapKey, setMapKey] = useState("");
  const [useGoogleMaps, setuseGoogleMaps] = useState(true);
  const [lang, setLang] = useState(i18next.language);
  const [fetchedConfig, setfetchedConfig] = useState(null);

  // 2) useEffect
  useEffect(() => {
    //console.log("Server Settings :", server_settings[1].dataB.ServerInfo);
    console.log("Server Settings. dataA :", server_settings[0].dataA);
    let dataA = server_settings[0].dataA;
    let dataB = server_settings[1].dataB.ServerInfo;

    setfetchedConfig(dataA);

    dispatch(
      redux_LoginSettings({
        ServerID: dataA.server_id,
        ServerName: dataA.server_name,
        web_server_url: dataB.driverAPIURL,
      })
    );

    setwebUrl(dataB.driverAPIURL);
    setserverID(dataA.server_id);
    setuseCustomeApiKey(dataA.Use_Custom_Map_Key);
    setMapKey(dataA.Map_Key);
    setuseGoogleMaps(!dataA.Use_Here_Maps);

    return;
  }, []);

  // 3) Function
  function isMyScriptLoaded(url) {
    var scripts = document.getElementsByTagName("script");
    for (var i = scripts.length; i--; ) {
      if (scripts[i].src == url) return true;
    }
    return false;
  }

  const login = async () => {
    setwrong(false);
    let formIsOK = await checkCredentials();

    if (formIsOK) {
      userLogin();
    } else {
      setwrong(true);
      seterrorMessage("Παρακαλώ συμπληρώστε τα στοιχεία.");
    }
  };

  const checkCredentials = () => {
    let x = username.length > 0;
    let y = password.length > 0;

    let result = x && y;

    return result;
  };

  const handleChange = (event) => {
    setprefix(event.target.value);
  };

  const userLogin = async () => {
    try {
      const response = await loginApi(webUrl, username, md5(password), prefix);
      const tok = response.data.access_token;
      setToken(tok);

      // call the second API only if the first one succeeded
      const accountInfo = await getAccountConfig(webUrl, tok);
      const data = accountInfo.data.response.user;
      const cnfg = accountInfo.data.response.config;

      dispatch(
        redux_login({
          email: data.email,
          pass: data.pass,
          fname: data.firstname,
          sname: data.surname,
          address: data.address,
          city: data.city,
          country: data.country,
          mobile: data.mobile,
          serverid: data.serverId,
          dateReg: data.dateReg,
          activated: data.activated,
          canceledCalls: data.canceledCalls,
          dateLastCall: "2023-02-08T14:10:42.613",
          userComment: data.userComment,
          user_type: data.userType,
          geoX: data.longitude,
          geoY: data.latitude,
          DateTimeFormat: data.dateTimeFormat,
          DistanceUnits: data.distanceUnits,
          Currency: data.currency,
          CallCenterGetCost: data.callCenterGetCost,
          countryCode: data.countryCode,
          ValidationState: data.validationState,
          groupID: data.groupId,
          promoCode: data.promoCode,
          imageURL: data.imageURL,
          google_key: data.googleKey,
          calls_boundaries: {
            North: 35.736728,
            West: 23.416296,
            South: 34.864766,
            East: 26.36692,
          },
          allow_calls_for_select_drivers: data.allowCallsForSelectDrivers,
          allow_calls_for_favor_drivers: data.allowCallsForFavorDrivers,
          token: tok,
        })
      );

      dispatch(
        redux_LoginSettings({
          Language: lang,
        })
      );

      dispatch(
        redux_applicationSettings({
          server_name: fetchedConfig?.server_name,
          server_id: fetchedConfig?.server_id,
          ButtonsArray: cnfg.buttonsArray,
          Extra_Destinations_Array: cnfg.extra_Destinations_Array,
          CarTypesArray: cnfg.carTypesArray,
          Code_for_POS: cnfg.code_for_POS,
          Car_Type_Code_To_Show_Hotel: cnfg.car_Type_Code_To_Show_Hotel,
          Email_To_Inform: cnfg.email_To_Inform,
          ShowPrices: cnfg.showPrices,
          currencySymbol: cnfg.currencySymbol,
          ShowBanner: cnfg.showBanner,
          Refresh_Calls_Seconds: cnfg.refresh_Calls_Seconds,
          Use_Here_Maps: cnfg.use_Here_Maps,
          Use_Custom_Map_Key: fetchedConfig?.Use_Custom_Map_Key,
          Map_Key: fetchedConfig?.Map_Key,
          currentPage: "dashboard",
          ShowPOS: fetchedConfig?.ShowPOS,
        })
      );

      //change google key
      await GoogleKeyChange(useCustomeApiKey, useGoogleMaps, data);

      // Last, navigate

      navigate("/Dashboard");
    } catch (error) {
      console.log(error);
      setwrong(true);
      seterrorMessage("Λάθος στοιχεία, δοκίμασε ξανα.");
    }
  };

  function LanguageSelector({ setLang }) {
    const { i18n } = useTranslation();

    const handleLanguageChange = (event) => {
      //console.log(event.target.value);
      i18n.changeLanguage(event.target.value);
      setLang(event.target.value);
    };

    return (
      <select
        value={i18n.language}
        onChange={handleLanguageChange}
        className="Primary_Light_Background"
      >
        <option value="en">English</option>
        <option value="es">Ελληνικά</option>
      </select>
    );
  }

  const GoogleKeyChange = async (useCustomeApiKey, useGoogleMaps, data) => {
    if (useCustomeApiKey) {
      console.log("We are using custom Map_Key from config.json");
      //Google maps
      if (useGoogleMaps) {
        console.log("We are using Google maps");
        let x = isMyScriptLoaded(
          "https://maps.googleapis.com/maps/api/js?key=" +
            mapKey +
            "&libraries=places&callback=Function.prototype"
        );

        if (!x) {
          var head = document.getElementsByTagName("head")[0];
          var script = document.createElement("script");
          script.type = "text/javascript";
          script.src =
            "https://maps.googleapis.com/maps/api/js?key=" +
            mapKey +
            "&libraries=places&callback=Function.prototype";
          head.appendChild(script);
        }
      } else {
        console.log("We are using Here maps : ");
      }
    } else {
      console.log("Map_Key is fetch from Info Endpoint");

      if (useGoogleMaps) {
        console.log("We are using Google maps");
        let x = isMyScriptLoaded(
          "https://maps.googleapis.com/maps/api/js?key=" +
            data.googleKey +
            "&libraries=places&callback=Function.prototype"
        );

        if (!x) {
          var head = document.getElementsByTagName("head")[0];
          var script = document.createElement("script");
          script.type = "text/javascript";
          script.src =
            "https://maps.googleapis.com/maps/api/js?key=" +
            data.googleKey +
            "&libraries=places&callback=Function.prototype";
          head.appendChild(script);
        }
      } else {
        console.log("We are using Here maps ");
      }
    }
  };

  return (
    <>
      <Grid
        container
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          backgroundImage: LoginImage,
        }}
      >
        <div className=" LoginBackground w-full h-full flex justify-center items-center">
          <Grid
            container
            className="Primary_Light_Background"
            p={5}
            style={theme.cardMax300}
            spacing={1}
          >
            <img
              className=" w-28 md:w-48 lg:w-56 m-auto"
              alt="Logo"
              src={
                process.env.PUBLIC_URL +
                "/Images/" +
                server_settings[0].dataA.server_name +
                "/logo.gif"
              }
              //sx={{ width: 86, height: 86 }}
            />
            <Grid item xs={12} mb={2}>
              <h1 className="text-xl font-bold text-center">
                {t("LOGIN_PAGE")}
              </h1>
            </Grid>
            <Grid item xs={4}>
              <select
                id="countries"
                onChange={handleChange}
                value={prefix}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 h-11"
              >
                {prefixNums.map((element, index) => {
                  return (
                    <option key={index} value={element.prefix}>
                      {element.code}
                    </option>
                  );
                })}
              </select>
            </Grid>
            <Grid item xs={8}>
              <div className="relative ">
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <img
                    src={require("../Images/Universal/user.png")}
                    width="15"
                  />
                </div>
                <input
                  type="text"
                  id="input-group-1"
                  value={username}
                  onChange={(type) => setusername(type.target.value)}
                  style={{ fontSize: 16 }}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5"
                  placeholder={t("Username")}
                />
              </div>
            </Grid>
            <Grid item xs={12}>
              <div className="relative mb-6">
                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                  <img
                    src={require("../Images/Universal/padlock.png")}
                    width="15"
                  />
                </div>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(type) => setpassword(type.target.value)}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5  "
                  placeholder={t("Password")}
                  style={{ fontSize: 16 }}
                />
              </div>
            </Grid>
            <Grid item xs={12} mt={0}>
              <button
                onClick={login}
                className="Primary_Dark_Background text-white  py-2 px-4 rounded w-full hover:scale-1"
              >
                <Typography variant="body1"> {t("Login")}</Typography>
              </button>
            </Grid>
            <Grid item xs={12} mt={1}>
              <Typography variant="body2" style={{ textAlign: "center" }}>
                {t("Version")} : {packageJson.version}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body2" style={{ textAlign: "center" }}>
                {t("Language")} : <LanguageSelector setLang={setLang} />
              </Typography>
            </Grid>

            <Grid item xs={12} mt={2}>
              {wrong && (
                <AlertComponent
                  message={errorMessage}
                  status={"Error"}
                  setClose={setwrong}
                />
              )}
            </Grid>
          </Grid>
        </div>
      </Grid>
    </>
  );
}

export default Login;

export const loginLoader = async () => {
  let sid = -1;
  let dataA = null;
  let dataB = null;
  let data = [{ dataA }, { dataB }];

  //Get Global values
  let results = await fetch("./config.json");
  if (results.ok) {
  } else {
    console.log("ERROR ON FETCH");
    alert(
      "Erron while trying to fetch Application Settings from config.json file"
    );
  }
  dataA = await results.json();
  sid = dataA.server_id;

  //Get server Settings
  results = await fetch(
    "https://www.iqtaxi.com/smartaxi.gr/client.aspx?calltype=serv_info&sid=" +
      sid
  );
  if (results.ok) {
  } else {
    console.log("ERROR ON FETCH");
    alert(
      "Erron while trying to fetch Application Settings from config.json file"
    );
  }
  dataB = await results.json();

  data = [{ dataA }, { dataB }];

  return await data;
};
